import { useState } from "react";
import { Plus } from "lucide-react";
import { Textarea } from "../../../components/ui/textarea";
import { Label } from "../../../components/ui/label";
import { useI18n } from "../../../i18n";
import { publicFileUrl } from "../../../lib/plans";
import { Group, Field, SaveBar, Toggle, UploadField, RowTools, move, useDraft, useSectionSave } from "./shared";

export const TutorialsSection = () => {
  const { t } = useI18n();
  const { settings, save, busy } = useSectionSave();
  const [items, setItems] = useDraft(settings.tutorials);
  const [pub, setPub] = useState(settings.tutorials_public);
  const [dash, setDash] = useState(settings.tutorials_dashboard);
  const upd = (i, k, v) => setItems(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const add = () => setItems([...items, { id: `tut_${Date.now().toString(36)}`, key: "", title: "New tutorial", description: "", url: "", video_path: null }]);
  return (
    <div className="space-y-6">
      <Group title="Where tutorials appear">
        <Toggle label="Show on the public home page" checked={pub} onChange={setPub} testId="tut-public-toggle" />
        <Toggle label="Show as a tab in member dashboards" checked={dash} onChange={setDash} testId="tut-dashboard-toggle" />
      </Group>
      {items.map((x, i) => (
        <Group key={x.id} title={x.title || (x.key ? t(`tut_${x.key}`) : "Untitled")}>
          <div className="flex justify-end"><RowTools onUp={() => setItems(move(items, i, -1))} onDown={() => setItems(move(items, i, 1))} onDelete={() => setItems(items.filter((_, j) => j !== i))} testId={`tut-${x.id}`} /></div>
          <Field label="Title" value={x.title} placeholder={x.key ? t(`tut_${x.key}`) : ""} onChange={(v) => upd(i, "title", v)} testId={`tut-${x.id}-title-input`} />
          <div className="space-y-1.5"><Label>Description</Label><Textarea rows={2} value={x.description} placeholder={x.key ? t(`tut_${x.key}_d`) : ""} onChange={(e) => upd(i, "description", e.target.value)} data-testid={`tut-${x.id}-desc-input`} /></div>
          <Field label="YouTube link" value={x.url} placeholder="https://www.youtube.com/watch?v=..." onChange={(v) => upd(i, "url", v)} testId={`tut-${x.id}-url-input`} />
          <UploadField label="…or upload a video file (used instead of the YouTube link)" kind="video" accept="video/mp4,video/webm" path={x.video_path} onChange={(v) => upd(i, "video_path", v)} testId={`tut-${x.id}-video`}
            hint="MP4 or WEBM, up to 100MB." preview={<video src={publicFileUrl(x.video_path)} className="h-14 w-24 rounded border bg-black object-cover" />} />
        </Group>
      ))}
      <div className="flex flex-wrap gap-3">
        <button type="button" onClick={add} className="btn-ghost-gold" data-testid="tut-add-btn"><Plus className="h-4 w-4" />Add tutorial</button>
        <SaveBar onClick={() => save({ tutorials: items, tutorials_public: pub, tutorials_dashboard: dash })} busy={busy} testId="tutorials-save-btn" />
      </div>
    </div>
  );
};
